<template>
  <div class="section-scene newZone">
    <div class="newZone-bg"></div>
    <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
    <img :src="static_img_url + 'pic/index/newzone_rank_pic.png'" class="bg-img">
    <div class="container">
        <div class="left-body">
            <div class="content content-enter">
                <div>
                  <p><img :src="static_img_url + 'pic/index/logo1.png'" class="logo-vb100"></p>
                </div>
                <div>
                    <p class="gold-tle">大企业榜</p>
                </div>
                <div>
                  <p class="summary">
                    在医疗健康产业域边的过程中<br>
                    传统器械、医药企业似漂亮转身的大象<br>
                    他们勇敢拥抱创新，踏出传统医疗的边界<br>
                    不断探索未来医疗新定义
                  </p>
                </div>
            </div>
        </div>
        <div class="slider-body slider-body-enter">
            <div class="swiper-container newzone-ul" ref="slider">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in newZone" :key="index">
                  <div class="newzone-item" >
                    <div class="newzone-base-side">
                      <div class="newzone-num">
                        <img :src="static_img_url + item.url">
                      </div>
                      <div class="newzone-item-content">{{item.summary}}</div>
                      <p>{{item.name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <div class="slider-href">
            <a :href="sliderHref" target="_blank" class="slider-a slider-a-enter">
              <!-- <i class="iconfont">&#xe678;</i> -->
              报名参选
            </a>
            <!-- <a class="slider-a slider-a-enter"></a> -->
        </div>
    </div>
    <div class="newZone-bg-leave translate-down"></div>
  </div>
</template>

<script>
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'
import Swiper from "swiper"

export default {
  mixins:[anima_mixins],
  data(){
    return {
      static_img_url: process.env.VUE_APP_CDN,
      defaultPage: 3,

      newzoneUl: '',
      newZone:[
        {
          name: '大药企创新研发实力榜',
          summary: '在充斥着不确定性的制药行业，企业创新往往伴随着高投入高风险，因此也显得弥足珍贵。本榜单，根据大药企已披露的产品管线情况，以及过去一年创新药的营收占比，对各大药企的创新研发实力进行评估排行，反映了药企将产品从一期、二期临床试验阶段以及市场商业化的能力。',
          url: 'pic/index/1.png',
          href: 'http://vcbeat-vb100.mikecrm.com/RUqoCKd'
        },
        {
          name: '外资企业中国创新力排行榜',
          summary: '持续创新是保持生命力唯一的选择，数字化转型时代，外资企业开放合作，链接创新资源是保持创新力的重要手段。本榜单根据外资企业在中国链接的创新企业数量、估值，合作的高校/科研机构数量等维度，对外资企业进行评估排行，反映在医疗科技创新价值链上的渗入、链接的创新力。',
          url: 'pic/index/2.png',
          href: 'http://vcbeat-vb100.mikecrm.com/iPmDTgd'
        },
        {
          name: '巨头跨界布局排行榜',
          summary: '近年来，科技医疗、地产、家电等行业巨头纷纷进军医疗行业，通过各具特色的战略思路布局，逐渐勾勒出自己的行业版图。本榜单，根据巨头公司在医疗产业的投资金额、投资/并购企业数量/估值、产业基金等维度，对跨界巨头企业进行评估排行，反映企业在医疗行业的布局思路及程度。',
          url: 'pic/index/3.png',
          href: 'http://vcbeat-vb100.mikecrm.com/OvxrcSX'
        },
      ],
      sliderHref: '',
      activeSwiIdx: 1
    }
  },
  watch:{
    activePage(n,o){ // 监听进入
      if( this.activePage == this.defaultPage && !this.newzoneUl ){
        this.initSwiper()
      }
    }
  },
  methods:{
    initSwiper(){
      let _that = this
      _that.newzoneUl = new Swiper('.newzone-ul', {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop : true,
        pagination: {
          el: ".swiper-pagination",
          type: "custom",
          renderCustom: (swiper, current, total) => {
            var customPaginationHtml = "";
            for (var i = 0; i < total; i++) {
              //判断哪个分页器此刻应该被激活
              if (i == current - 1) {
                customPaginationHtml +=
                  '<span class="swiper-pagination-bullet swiper-pagination-bullet-active"><span></span></span>';
              } else {
                customPaginationHtml +=
                  '<span class="swiper-pagination-bullet"></span>';
              }
            }
            this.sliderHref = this.newZone[current - 1].href
            return customPaginationHtml;
          }
        }
      });
    },
    async downEnter(){
      // console.log('newZone:下 进入')
      await timeoutSync(() => {
        $('.newZone-bg').addClass('newZone-enter-bg')
      },100)
      await timeoutSync(() => {
        $(".slider-body").removeClass('slider-body-enter')
        $(".slider-a").removeClass('slider-a-enter')
        $('.content').removeClass('content-enter')
      },300)
      await timeoutSync(() => {
        this.$emit('setLock',true)
      }, 600)
    },
    async upEnter(){
      //  console.log('newZone:上 进入')
       await timeoutSync(() => {
        $('.newZone-bg-leave').addClass('translate-down')
        $('.content').removeClass('content-enter')
      },100)
       await timeoutSync(() => {
        this.$emit('setLock',true)
      }, 600)
    },

    async upLeave(){
      // console.log('newZone:上 离开')
      this.$emit('setLock',false)
      $(".slider-body").addClass('slider-body-enter')
      $(".slider-a").addClass('slider-a-enter')
      $('.newZone-bg').removeClass('newZone-enter-bg')
      $('.content').addClass('content-enter')
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
      },600)
    },
    async downLeave(){
      // console.log('newZone:下 离开')
      this.$emit('setLock',false)
      $('.newZone-bg-leave').removeClass('translate-down')
      $('.content').addClass('content-enter')
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
      }, 600)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';
@import "../../../node_modules/swiper/dist/css/swiper.css";

.newZone
  .newZone-bg
    position absolute
    top 0
    left 0
    width 100vw
    height 100vw
    transition all .6s
    background: #000000;
    z-index 4
    &.newZone-enter-bg
      width px2vw(960)
  .bg-img
      position absolute
      right 0
      top 0
      z-index -1
      width: 50%
      height 100%
      object-fit: cover
      object-position: 50% 50%
  .container
      display flex
      flex-direction row
      .left-body
          position relative
          z-index 5
          width px2vw(960)
          min-width 600px
          height 100vh
          background #000
          padding-left px2vw(240)
          .content
              position relative
              top px2vh(300)
              .logo-vb100
                  width px2vw(540)
              .gold-tle
                  margin-top 40px
              .summary
                  margin-top 40px
                  font-size:32px;
                  color:#FFFFFF
                  line-height:46px;
              @media screen and (max-width: 1366px)
                .gold-tle
                  margin-top 30px
                  font-size 40px !important
                .summary
                  margin-top 28px
                  font-size: 20px;
                  line-height: 30px;
      .slider-body
          position relative
          margin-top auto
          width: px2vw(740)
          height: px2vh(440)
          background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
          transition all .6s
          &.slider-body-enter
            transform translateY(100%)
          .newzone-ul
            width:100%;
            height 100%
            background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
            position:relative;
            z-index:1;
            .swiper-slide
              width: px2vw(740)
            .newzone-item
              width:100%;
              height 100%
              padding px2vh(60) px2vw(60)
              z-index:1;
              .newzone-base-side
                position relative
                height 100%
                .newzone-num
                  position absolute
                  top 10px
                  left 10px
                  width: px2vw(50)
                  img
                    width:100%
                .newzone-item-content
                  position absolute
                  right 0
                  width: 330px
                  font-size:14px;
                  font-weight:400;
                  color:rgba(0,0,0,1);
                  line-height:22px;
                  @media screen and (max-width: 1366px)
                    width: 300px
                p
                  position absolute
                  left 0
                  bottom 0
                  font-size: 22px;
                  color:rgba(0,0,0,1);
                  @media screen and (max-width: 1366px)
                    font-size: 14px;
          .swiper-pagination
            bottom: px2vh(50)
            right: px2vw(80)
            left:auto;
            width: 100%;
            text-align: right;
            position:absolute;
            z-index:2;
            >>> .swiper-pagination-bullet
              width: 40px 
              height: 2px;
              z-index:2;
              margin-left: 10px;
              background #A87115
              border-radius: 0
              opacity: 1
            >>> .swiper-pagination-bullet-active span
                height:100%;
                display:block;
                z-index:10;
                background:#fff;
                animation : progress 5s linear
      .slider-href
          position relative
          margin-top auto
          width: px2vw(220)
          height: px2vw(220)
          a
            position absolute
            right 0
            bottom 0
            display inline-flex
            justify-content center
            align-items center
            width 100%
            height 100%
            transition all .6s
            background: #232323;
            overflow hidden
            color #fff
            font-size 21px
            &:hover
              color #F4B245
            // i 
            //     font-size 21px
            //     color #fff
            //     transition all .4s
            // &:hover
            //     i 
            //         color #F4B245
            &.slider-a-enter
              width: 0
              height: 0
  .newZone-bg-leave
    position absolute
    background #232323
    bottom 0
    width 100vw
    height 100vh
    z-index 20
    transition all .6s
    transform translate(0,0)

</style>